module.exports = __webpack_public_path__ + "static/media/ic_open_in_new.02c16573.svg";